import { i18nNsFactory } from '@atlas-frontend/i18n';
import { FC, useMemo } from 'react';
import { FormField, FormSelect, FormSelectProps } from '../../common/form';
import { useDataSourceConnectionsQuery } from '../query/useDataSourceConnectionsQuery';
import { DataSourceFormDataType } from '../schema';

import translations from './ConnectionField.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('connection-field');
addTranslations(translations);

export type ConnectionFieldProps = Omit<
  FormSelectProps<DataSourceFormDataType, 'connectionId'>,
  'name' | 'options'
>;

export const ConnectionField: FC<ConnectionFieldProps> = (props) => {
  const { t } = useTranslation();
  const { data: connections } = useDataSourceConnectionsQuery();

  const options = useMemo(
    () =>
      (connections || []).map(({ connectionId }) => ({
        label: connectionId,
        value: connectionId,
      })),
    [connections],
  );

  return (
    <FormField name="connectionId" label={t('label')} required>
      <FormSelect
        name="connectionId"
        options={options}
        showSearch
        allowClear
        filterOption
        {...props}
      />
    </FormField>
  );
};
